import { skipToken } from '@reduxjs/toolkit/query/react'
import { useFetchUserStatusQuery } from '@/api/user-api'
import isQuotaBasedWorkspaceType from '@/utils/workspace/is-quota-based-workspace-type'

const useIsQuotaBasedWorkspace = (skip?: boolean): boolean => {
  const { data: userStatus } = useFetchUserStatusQuery(
    skip ? skipToken : undefined,
  )

  const workspaceType = userStatus?.currentWorkspace?.workspaceType
  return workspaceType ? isQuotaBasedWorkspaceType(workspaceType) : false
}

export default useIsQuotaBasedWorkspace
